var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "zoom-on-hover",
      on: {
        mousemove: _vm.move,
        mouseover: _vm.move,
        mouseenter: _vm.zoom,
        mouseleave: _vm.unzoom,
      },
    },
    [
      _c("img", {
        ref: "normal",
        staticClass: "normal aspect-[4.5/3] object-cover object-center",
        attrs: {
          alt: _vm.alt,
          loading: _vm.isLazyLoad ? "lazy" : false,
          width: _vm.width,
          height: _vm.height,
          src: _vm.imgNormal,
          srcset: `${_vm.imgMobile} 767w, ${_vm.imgNormal} 1024w`,
        },
      }),
      _vm._v(" "),
      _c("img", {
        ref: "zoom",
        staticClass: "zoom",
        attrs: {
          alt: _vm.alt,
          loading: "lazy",
          src: _vm.imgZoom,
          srcset: `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg== 767w, ${_vm.imgZoom}`,
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }